/*
 * @Author: Latte
 * @Date: 2021-11-17 14:57:49
 * @LAstEditors: Latte
 * @LastEditTime: 2021-12-29 10:05:26
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\statisticsManagement\statisticalData.js
 */
import request from "@/utils/request";
import config from "@/utils/config";


/**
 * 后台分页获取用户登录信集合
 * @param params
 * @returns {*}
 */
 export function getUserLoginList(params) {
  return request({
    url: config.API_ADMIN + '/Api/V1/AdminDataStatistics/UserLoginList',
    method: 'get',
    params
  })
}

/**
 * 后台获取用户相关统计数据数目
 * @param params
 * @returns {*}
 */
export function getUserDataStatistics(params) {
    return request({
        url: config.API_ADMIN + '/Api/V1/AdminDataStatistics/User',
        method: 'get',
        params
    })
}